import React, { Fragment, useState } from "react";
import Navbar from "./components/layout/Navbar";
import ProjectContainer from "./components/layout/ProjectContainer";
import Footer from "./components/layout/Footer";
import { LanguageProvider } from "./components/context/LanguageContext";
import Toolbar from "./components/layout/Toolbar";

function App() {
  return (
    <Fragment>
      <LanguageProvider>
        <Navbar />
        <div className="main-area">
          <Toolbar />
          <ProjectContainer />
        </div>
        <Footer />
      </LanguageProvider>
    </Fragment>
  );
}

export default App;
